export default __webpack_public_path__ + "static/media/aron-kodesh1-mission.f82b581d.png";